export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13102.a9358f03.jpg";